<template>
  <div class="etms-body">
    <div class="etms-header">
      <div :class="[isSmall ? 'logo' : 'logo-big', 'fl']">
        <img :src="[isSmall ? '/static/logo-small.png' : '/static/logo.png']" alt="" />
      </div>
      <div class="sidebar-toggle fl" @click="handleSmall">
        <i class="iconfont icon-menu"></i>
      </div>
      <div class="header-menu fl">
        <ul>
          <li v-for="menu in menulist.filter(item => item.parentMenuId==='00000000-0000-0000-0000-000000000000')" :key="menu.id" :class="[menu.id===menuid?'is-active':'','fl cursor']" @click="menuid=menu.id;">{{menu.menuName}}</li>
          <li class="fr">

          </li>
        </ul>
      </div>
      <div class="header-menu fr">
        <el-dropdown trigger="click" @command="handleClick">
          <span class="el-dropdown-link">
            {{userinfo.nickName}}[{{userinfo.name}}]
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="home">首页</el-dropdown-item>
            <el-dropdown-item command="exitLogin">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div :class="[isSmall ? 'left-small' : 'left-big','left fl']">
      <el-menu router :default-active="$route.path" @select="handleSelect" @open="handleOpen" @close="handleClose" :collapse="isSmall" background-color="#545c64" text-color="#ffffff" active-text-color="#ffd04b">
        <template v-for="menu in menulist.filter(item => item.parentMenuId === menuid)">
          <el-submenu :index="menu.id" :key="menu.id">
            <template slot="title">
              <i :class="['iconfont',menu.icon]"></i>
              <span>{{menu.menuName}}</span>
            </template>
            <template v-if="menulist.filter(m=>m.parentMenuId===menu.id).length > 0">
              <el-menu-item v-for="c in menulist.filter(m=>m.parentMenuId===menu.id)" :key="c.id" :index="c.path">
                <template slot="title">
                  <i :class="['iconfont',c.icon]"></i>
                  <span>{{c.menuName}}</span>
                </template>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div :class="[isSmall ? 'content-small' : 'content-big', 'etms-content fl']">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
Vue.prototype.$ajax = axios

export default {
  data () {
    return {
      menuid: '',
      menus: this.menumodule.menus,
      isSmall: true,
      menulist: [],
      userinfo: {
        id: '',
        enterpriseId: '',
        loginName: '',
        loginHostAddress: '',
        loginToken: '',
        loginPassword: '',
        name: '',
        nickName: ''
      },
    }
  },
  watch: {
    $route (to, form, next) {
      this.common.existsUserLogin(this)
    }
  },
  mounted () {
    this.common.existsUserLogin(this)
    var self = this
    var menustr = ''



    // if (self.$cookies.get('menutotal') !== null && self.$cookies.get('menutotal') !== undefined) {
    //   for (let index = 1; index < parseInt(self.$cookies.get('menutotal')) + 1; index++) {
    //     const element = self.$cookies.get('menutotal');
    //     menustr += self.$cookies.get('menulist-' + index)
    //   }
    // }
    // var menus = JSON.parse(menustr)
    // var user = self.$cookies.get('userinfo')

    // if (menus === undefined || menus === null || menus.loginToken !== user.loginToken) {
    this.$ajax({
      method: 'post',
      url: this.constant.openPaths.getUserMenus,
      data: {
        UserId: this.userinfo.id,
        LoginToken: this.userinfo.loginToken,
        EnterpriseId: this.userinfo.enterpriseId
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        self.menulist = res.data.result
        // var menus = {
        //   loginToken: user.loginToken,
        //   menulist: self.menulist
        // }
        // var menustr = JSON.stringify(menus)

        // self.stringLengthHandler(menustr, 1)

        self.menuid = res.data.result.filter(m => m.parentMenuId === '00000000-0000-0000-0000-000000000000')[0].id
      } else {
        self.$message.error(res.data.msg)
      }
    }).catch(function (error) {
      self.$message.error(error)
    })
    // } else {
    //   this.menulist = menus.menulist
    //   self.menuid = this.menulist.filter(m => m.parentMenuId === '00000000-0000-0000-0000-000000000000')[0].id
    // }

  },
  methods: {
    stringLengthHandler (str, pageindex) {
      var cookiename = 'menulist-' + pageindex
      var timelong = 60 * 60 * 24
      var long = 2000
      if (pageindex === 1 && str.length <= pageindex * long) {
        this.$cookies.set(cookiename, str, timelong)
        this.$cookies.set('menutotal', pageindex)
      } else {
        if (pageindex === 1) {

          this.$cookies.set(cookiename, str.substring((pageindex - 1) * long, long), timelong)
        }
        else {
          this.$cookies.set(cookiename, str.substring((pageindex - 1) * long, str.length - (str.length - pageindex * long)), timelong)
        }
        if (str.length - (str.length - pageindex * long) < str.length) {
          this.stringLengthHandler(str, pageindex + 1)
        }
        else {
          this.$cookies.set('menutotal', pageindex)
        }
      }
    },
    handleClick (command) {
      switch (command) {
        case 'exitLogin':
          this.exitLogin()
          break
        case 'home':
          this.$router.push({ name: 'index' })
          break
        default:
          break
      }
    },
    exitLogin () {
      var self = this
      this.$ajax.post(this.constant.openPaths.exitLogin,
        {
          UserId: this.userinfo.id,
          LoginToken: this.userinfo.loginToken,
          LoginHostAddress: this.userinfo.loginhostaddress
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          self.$cookies.remove('userinfo')
          self.$router.push({ name: 'index' })
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    },
    handleSmall () {
      if (this.isSmall) {
        this.isSmall = false
      } else {
        this.isSmall = true
      }
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style>
@import "../../css/etms/home.css";
@import "../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/home.vue